var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnboarding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 214.972,
    height: 235.407,
    viewBox: "0 0 214.972 235.407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#caf1ef;}.b{fill:#48d1cc;}.c,.j,.k{fill:#ffffff;}.d,.l{fill:#dbdaea;}.e{fill:#fff;}.f{fill:#fef4d9;}.g{fill:#f6e2bb;}.h{fill:#d2a96f;}.i{fill:#e7c798;}.j{fill-rule:evenodd;}.k{font-size:9px;font-family:SegoeUI-Bold, Segoe UI;font-weight:700;}.l{stroke:#4b4495;}.m{fill:#383377;}.n{fill:#262d44;}.o{fill:#f9ba85;}.p{fill:none;}.q{fill:#e7985d;}.r{fill:#c7dadd;}.s{fill:#dfe9eb;}.t,.u{fill:#763c26;}.u{opacity:0.15;}.v{fill:#682917;}.w{fill:#f9ddc5;}.x{fill:#1c2235;}.y{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 22.067,
    y: 151.77,
    width: 24.323,
    height: 30.355,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-333.751 -380.231)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(478.706 441.745) rotate(21)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 0, 6.034)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.228 37.642) rotate(140)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12.549,
    height: 10.567,
    transform: "translate(0 38.571)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.549,24.569a12.02,12.02,0,1,1,24.041,0v11.36H49.138V24.569A24.569,24.569,0,1,0,0,24.569v11.36H12.549Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12.549,
    height: 10.567,
    transform: "translate(36.59 38.571)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.68 496.04)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.789 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M636.375,505.035l-53.927,5.573a3.1,3.1,0,0,1-3.392-2.757L567.91,400.009a3.1,3.1,0,0,1,2.756-3.392l53.928-5.573a3.1,3.1,0,0,1,3.392,2.757l11.145,107.843A3.1,3.1,0,0,1,636.375,505.035Z",
    transform: "translate(-567.894 -391.028)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M829.227,1120.1a2.027,2.027,0,1,0-1.808,2.224A2.027,2.027,0,0,0,829.227,1120.1Z",
    transform: "translate(-782.816 -1008.498)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 52.998,
    height: 101.045,
    rx: 1,
    transform: "translate(3.676 9.033) rotate(-5.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 46.771,
    height: 28.129,
    transform: "translate(14.518 75.328) rotate(-5.9)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.601 22.447) rotate(-7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M0,1.557,19.541,0l7.3,2.523L9.395,5.852Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M9.663,2.631,0,0V16.09l9.663,2.861Z",
    transform: "translate(0 1.558)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M0,1.664v16.32l17.179-1.825V0Z",
    transform: "translate(9.662 2.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M9.885,5.064,9.472,3.024,6.365,3.44,5.93,0,2.721.473l.824,3.345L0,4.294l.645,2.87,3.525-.8.949,3.855,2.044-.462-.5-3.96Z",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 13.982, 6.435)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 38.54, 85.081)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.425,
    y: 0
  }, "OFFER"), /*#__PURE__*/React.createElement("tspan", {
    x: -19.373,
    y: 9,
    xmlSpace: "preserve"
  }, " APPLIED"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.042 54.594)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M673.518,784.29a3.382,3.382,0,0,0-.475-.253,3.24,3.24,0,0,0-1.472-.206,3.04,3.04,0,0,0-2.58,2.121,2.848,2.848,0,0,0-.126,1.219,3.049,3.049,0,0,0,3.339,2.706,2.8,2.8,0,0,0,1.741-.807,2.945,2.945,0,0,0,.965-2.532A3.011,3.011,0,0,0,673.518,784.29Z",
    transform: "translate(-667.805 -781.718)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M766.428,768.875l-28.836,2.98a.535.535,0,0,1-.586-.476l-.012-.117a.536.536,0,0,1,.476-.586l28.836-2.98a.536.536,0,0,1,.586.476l.012.117A.535.535,0,0,1,766.428,768.875Z",
    transform: "translate(-726.385 -767.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M767.91,783.216l-28.836,2.98a.536.536,0,0,1-.586-.476l-.012-.118a.535.535,0,0,1,.476-.586l28.836-2.98a.535.535,0,0,1,.586.476l.012.117A.535.535,0,0,1,767.91,783.216Z",
    transform: "translate(-727.651 -779.934)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.742 32.972)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(323.122 484.873)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.886 20.365)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 9,
    height: 21,
    transform: "translate(10.943 -0.572)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M125.512,342.655s-7.21,1.507-7.452,3.6-.242,1.318-.242,1.318h13.056s.727-3.554-.16-4.713Z",
    transform: "translate(-117.818 -270.288)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M138.991,332.973v3.518a6.243,6.243,0,0,0,5.2.207v-3.726Z",
    transform: "translate(-131.297 -264.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M177.254,342.655s7.21,1.507,7.452,3.6.242,1.318.242,1.318H171.892s-.727-3.554.16-4.713Z",
    transform: "translate(-153.662 -270.288)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M178.026,332.973v3.518a6.243,6.243,0,0,1-5.2.207v-3.726Z",
    transform: "translate(-154.434 -264.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M134.353,206.559s0,41.084.824,47.374c0,0,4.024.926,5.67,0l.667-35.753h.932l2.919,36.164s4.426.871,5.823,0l-2.076-47.422Z",
    transform: "translate(-127.458 -183.646)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.026)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M212.733,170.735l3.279,12.576v29.711s-8.638-.135-9.124-3.109S204,174.1,207.965,171.781Z",
    transform: "translate(-205.722 -170.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.143,12.3,2.727,0,0,.636,2,3.226.681,5.443Z",
    transform: "translate(4.318 -0.209) rotate(1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M208.985,170.735l-3.263,12.576v29.711s8.6-.135,9.081-3.109,2.875-35.81-1.073-38.132Z",
    transform: "translate(-205.658 -170.735)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "y",
    transform: "matrix(1, 0, 0, 1, -31.12, -157.98)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,12.25,3.4,0,6.11.712l-1.979,2.5L5.442,5.423Z",
    transform: "translate(31.07 157.88) rotate(-1)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.625)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.325 22.453)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M152.389,152.262l.975,1.552-1.868,9.229s1.605,5.8,2.674,5.8,2.948-6.626,2.948-6.626l-1.88-8.512.518-1.444-1.357-1.294Z",
    transform: "translate(-151.496 -150.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M156.637,158.613a2.935,2.935,0,0,0,1.874-.108",
    transform: "translate(-154.769 -155.766)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.093 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.299)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M706.845,262.523a1.346,1.346,0,0,1-.906-.666c-.413-.625-1.23-1.576-1.109-2.2s1.123-1.04,1.123-1.04.163-2.881,1.709-2.274a1.15,1.15,0,0,1,.965-.328,1.253,1.253,0,0,1,.708.692,1.085,1.085,0,0,1,1.253,1s.931-.047.76,1.089-.491,1.46-.75,1.568a2.831,2.831,0,0,1-1.325,2.512l-1.427.54Z",
    transform: "translate(-704.818 -255.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M712.293,270.461s1.828-.537,2.126.175-1.579,1.5-1.579,1.5a2.78,2.78,0,0,1,2.112,1.777,2.325,2.325,0,0,0-.739-1.857l.342-.181s.6.889,1.252.085a.668.668,0,0,0,1.131.249s-.966-.128-.973-.962c0,0-.6.934-1.235.137a.765.765,0,0,0,.069-1.017C714.4,269.77,713.214,269.847,712.293,270.461Z",
    transform: "translate(-711.158 -267.837)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.46)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M585.574,330.6s-2.271-2.683-.68-6.986c0,0,12.9-1.149,19.3-13.431l2.184.447S601.455,326.369,585.574,330.6Z",
    transform: "translate(-584.329 -308.409)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M713.141,301.452l-3.231-.729.923-2.2A9.9,9.9,0,0,1,713.6,299Z",
    transform: "translate(-690.837 -298.528)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.099 -5.784) rotate(23)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M388.052,416.415s.736-3-1.42-7.048a24.278,24.278,0,0,1-19.777-10.677l-2.1.736S371.746,414.364,388.052,416.415Z",
    transform: "translate(-361.801 -391.009)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M349.619,526.361a5.145,5.145,0,0,0,1.17-1.6,18.464,18.464,0,0,0,.092-2.262c.055-.664-.07-1.464-.991-1.017a9.958,9.958,0,0,0-1.578-1.262.713.713,0,0,0-1.087.859,1.144,1.144,0,0,0-.736,1.157,1.744,1.744,0,0,0-.658,1.276s-.671.207-.465,1.091a5.187,5.187,0,0,0,1.569,2,3.88,3.88,0,0,0,1.131.447Z",
    transform: "translate(-345.328 -520.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M359.307,508.909l3.1-1.157L361.2,505.7a9.9,9.9,0,0,0-2.682.842Z",
    transform: "translate(-356.515 -499.755)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.224 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M514.253,288.512s1.894,5.468,9.014,5.406,8.8-4,8.253-7.591-2.036-5.171-1.542-9.677l-16.2.97-.8,4.485Z",
    transform: "translate(-511.136 -272.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M505.092,260.174s3.487-.742-.477-5.554c0,0,7.248,3.444,12.875-2.549,0,0,2.961,1.554,3.811-.106s-.82-3.247-3-3.7c0,0,1.739-.31,1.305-1.137s-2.609-.425-3.462.375a14.047,14.047,0,0,0-8.814-.3c-4.579,1.464-5.413,4.658-5.375,5.888,0,0-2.912,2.192.725,7.289Z",
    transform: "translate(-500.857 -246.618)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M517.228,249.536s2.228,2.451,4.306,1.4c-.1-1.247-1.5-2.311-3.216-2.671,0,0,1.739-.31,1.305-1.137s-2.609-.425-3.461.375a14.047,14.047,0,0,0-8.814-.3c-4.58,1.464-5.413,4.658-5.375,5.888,0,0-2.031,1.533-.576,5.011a4.64,4.64,0,0,0,1.828-4.782A11.622,11.622,0,0,0,517.228,249.536Z",
    transform: "translate(-500.87 -246.618)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M509.369,333.29s-2.171-1.438-3.242.758,1.868,5.834,4.354,2.692Z",
    transform: "translate(-505.134 -319.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M513.646,340.386s-1.738-.9-2.2.421a1.519,1.519,0,0,0,1.822,2.048S511.38,341.212,513.646,340.386Z",
    transform: "translate(-509.741 -325.892)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M605.42,330c-.56.233-.376,3.083.918,3.295s1.822-.818,1.068-1.849C606.808,330.629,606.093,329.721,605.42,330Z",
    transform: "translate(-589.286 -317.293)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.551 16.327)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M580.747,355.255c-1.3-.131-2.767-1.99-3.595-.657s.558,3.188,2.808,3.179,3.428-1.538,2.9-2.336C582.379,354.713,581.681,355.349,580.747,355.255Z",
    transform: "translate(-576.91 -354.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M585.942,355.091a7.348,7.348,0,0,1-1.424.165c-1.1-.11-2.31-1.448-3.16-1.068-.023.606.233,1.627,2.168,1.817S585.873,355.513,585.942,355.091Z",
    transform: "translate(-580.681 -354.12)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.177 8.515)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M567.9,309.514c.365.462,2.713-.795,2.421-1.306S567.527,309.038,567.9,309.514Z",
    transform: "translate(-567.864 -307.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M611.292,302.922c-.074.486,1.7.813,1.777.327S611.367,302.436,611.292,302.922Z",
    transform: "translate(-604.695 -302.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M579,321.8c-.673.235-.682,2.775.518,2.571S579.585,321.6,579,321.8Z",
    transform: "translate(-576.92 -318.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M615.235,317.041c-.751.134-.328,2.391.465,2.159S615.9,316.923,615.235,317.041Z",
    transform: "translate(-607.708 -314.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M581.743,324.909c-.525.157-.177,1.378.247,1.162S582.077,324.809,581.743,324.909Z",
    transform: "translate(-579.411 -321.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M617.353,319.539c-.379.067-.073,1.058.261.959S617.685,319.48,617.353,319.539Z",
    transform: "translate(-609.689 -316.976)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(430.809 361.98) rotate(21)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.788, -0.616, 0.616, 0.788, 54.923, 45.59)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 18.356,
    height: 18.356,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.173 3.166)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.169,4.043l-.748-3A1.389,1.389,0,0,0,12.061,0H2.168A1.389,1.389,0,0,0,.815,1.043l-.748,3A2.252,2.252,0,0,0,.509,6.021a2.678,2.678,0,0,0,.2.2v4.764a1.4,1.4,0,0,0,1.424,1.373H12.1a1.4,1.4,0,0,0,1.424-1.373V6.22a2.589,2.589,0,0,0,.2-.192A2.245,2.245,0,0,0,14.169,4.043ZM7.831,1.373h1.4l.385,3.1a.9.9,0,0,1-.235.735.864.864,0,0,1-.677.281.888.888,0,0,1-.869-.9Zm-3.212,3.1.392-3.1h1.4v3.22a.9.9,0,0,1-.919.9.871.871,0,0,1-.634-.281A.952.952,0,0,1,4.618,4.476Zm-2.991.693a.91.91,0,0,1-.178-.8l.719-2.993h1.4L3.158,4.709a.883.883,0,0,1-.862.783A.845.845,0,0,1,1.627,5.169ZM12.1,10.984H2.133V6.844a1.335,1.335,0,0,0,.164.021,2.27,2.27,0,0,0,1.6-.652,2.335,2.335,0,0,0,1.645.652,2.3,2.3,0,0,0,1.588-.638,2.38,2.38,0,0,0,1.631.638,2.3,2.3,0,0,0,1.6-.652,2.27,2.27,0,0,0,1.6.652,1.335,1.335,0,0,0,.164-.021v4.14Zm.506-5.815a.845.845,0,0,1-.669.323.877.877,0,0,1-.862-.783l-.413-3.336,1.375-.007.748,3A.9.9,0,0,1,12.609,5.169Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.788, -0.616, 0.616, 0.788, 52.982, 11.302)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 18.356,
    height: 18.356,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.173 3.166)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.169,4.043l-.748-3A1.389,1.389,0,0,0,12.061,0H2.168A1.389,1.389,0,0,0,.815,1.043l-.748,3A2.252,2.252,0,0,0,.509,6.021a2.678,2.678,0,0,0,.2.2v4.764a1.4,1.4,0,0,0,1.424,1.373H12.1a1.4,1.4,0,0,0,1.424-1.373V6.22a2.589,2.589,0,0,0,.2-.192A2.245,2.245,0,0,0,14.169,4.043ZM7.831,1.373h1.4l.385,3.1a.9.9,0,0,1-.235.735.864.864,0,0,1-.677.281.888.888,0,0,1-.869-.9Zm-3.212,3.1.392-3.1h1.4v3.22a.9.9,0,0,1-.919.9.871.871,0,0,1-.634-.281A.952.952,0,0,1,4.618,4.476Zm-2.991.693a.91.91,0,0,1-.178-.8l.719-2.993h1.4L3.158,4.709a.883.883,0,0,1-.862.783A.845.845,0,0,1,1.627,5.169ZM12.1,10.984H2.133V6.844a1.335,1.335,0,0,0,.164.021,2.27,2.27,0,0,0,1.6-.652,2.335,2.335,0,0,0,1.645.652,2.3,2.3,0,0,0,1.588-.638,2.38,2.38,0,0,0,1.631.638,2.3,2.3,0,0,0,1.6-.652,2.27,2.27,0,0,0,1.6.652,1.335,1.335,0,0,0,.164-.021v4.14Zm.506-5.815a.845.845,0,0,1-.669.323.877.877,0,0,1-.862-.783l-.413-3.336,1.375-.007.748,3A.9.9,0,0,1,12.609,5.169Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.932 80.538) rotate(-39)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 18.356,
    height: 18.356,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.173 3.166)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.169,4.043l-.748-3A1.389,1.389,0,0,0,12.061,0H2.168A1.389,1.389,0,0,0,.815,1.043l-.748,3A2.252,2.252,0,0,0,.509,6.021a2.678,2.678,0,0,0,.2.2v4.764a1.4,1.4,0,0,0,1.424,1.373H12.1a1.4,1.4,0,0,0,1.424-1.373V6.22a2.589,2.589,0,0,0,.2-.192A2.245,2.245,0,0,0,14.169,4.043ZM7.831,1.373h1.4l.385,3.1a.9.9,0,0,1-.235.735.864.864,0,0,1-.677.281.888.888,0,0,1-.869-.9Zm-3.212,3.1.392-3.1h1.4v3.22a.9.9,0,0,1-.919.9.871.871,0,0,1-.634-.281A.952.952,0,0,1,4.618,4.476Zm-2.991.693a.91.91,0,0,1-.178-.8l.719-2.993h1.4L3.158,4.709a.883.883,0,0,1-.862.783A.845.845,0,0,1,1.627,5.169ZM12.1,10.984H2.133V6.844a1.335,1.335,0,0,0,.164.021,2.27,2.27,0,0,0,1.6-.652,2.335,2.335,0,0,0,1.645.652,2.3,2.3,0,0,0,1.588-.638,2.38,2.38,0,0,0,1.631.638,2.3,2.3,0,0,0,1.6-.652,2.27,2.27,0,0,0,1.6.652,1.335,1.335,0,0,0,.164-.021v4.14Zm.506-5.815a.845.845,0,0,1-.669.323.877.877,0,0,1-.862-.783l-.413-3.336,1.375-.007.748,3A.9.9,0,0,1,12.609,5.169Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 27.8) rotate(-39)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 24.926,
    height: 24.926
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.173 3.166)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20.707,6.193,19.614,1.6A2.049,2.049,0,0,0,17.626,0H3.169A2.049,2.049,0,0,0,1.191,1.6L.1,6.193A3.577,3.577,0,0,0,.744,9.222a4.013,4.013,0,0,0,.291.3v7.3a2.1,2.1,0,0,0,2.082,2.1H17.689a2.1,2.1,0,0,0,2.082-2.1v-7.3a3.87,3.87,0,0,0,.291-.294A3.565,3.565,0,0,0,20.707,6.193ZM11.444,2.1h2.04l.562,4.753A1.423,1.423,0,0,1,13.7,7.981a1.236,1.236,0,0,1-.989.431,1.332,1.332,0,0,1-1.27-1.377ZM6.749,6.856,7.322,2.1h2.04V7.035A1.345,1.345,0,0,1,8.019,8.412a1.247,1.247,0,0,1-.926-.431A1.5,1.5,0,0,1,6.749,6.856ZM2.378,7.918a1.445,1.445,0,0,1-.26-1.23L3.169,2.1h2.05l-.6,5.11a1.314,1.314,0,0,1-1.259,1.2A1.218,1.218,0,0,1,2.378,7.918Zm15.311,8.906H3.117V10.484a1.866,1.866,0,0,0,.239.032,3.241,3.241,0,0,0,2.331-1,3.33,3.33,0,0,0,2.4,1,3.283,3.283,0,0,0,2.321-.978,3.394,3.394,0,0,0,2.384.978,3.289,3.289,0,0,0,2.331-1,3.241,3.241,0,0,0,2.331,1,1.866,1.866,0,0,0,.239-.032v6.341Zm.739-8.906a1.218,1.218,0,0,1-.978.494,1.307,1.307,0,0,1-1.259-1.2l-.6-5.11L17.6,2.093l1.093,4.6A1.43,1.43,0,0,1,18.428,7.918Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.251 23.154) rotate(-39)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 24.926,
    height: 24.926
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.173 3.166)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20.707,6.193,19.614,1.6A2.049,2.049,0,0,0,17.626,0H3.169A2.049,2.049,0,0,0,1.191,1.6L.1,6.193A3.577,3.577,0,0,0,.744,9.222a4.013,4.013,0,0,0,.291.3v7.3a2.1,2.1,0,0,0,2.082,2.1H17.689a2.1,2.1,0,0,0,2.082-2.1v-7.3a3.87,3.87,0,0,0,.291-.294A3.565,3.565,0,0,0,20.707,6.193ZM11.444,2.1h2.04l.562,4.753A1.423,1.423,0,0,1,13.7,7.981a1.236,1.236,0,0,1-.989.431,1.332,1.332,0,0,1-1.27-1.377ZM6.749,6.856,7.322,2.1h2.04V7.035A1.345,1.345,0,0,1,8.019,8.412a1.247,1.247,0,0,1-.926-.431A1.5,1.5,0,0,1,6.749,6.856ZM2.378,7.918a1.445,1.445,0,0,1-.26-1.23L3.169,2.1h2.05l-.6,5.11a1.314,1.314,0,0,1-1.259,1.2A1.218,1.218,0,0,1,2.378,7.918Zm15.311,8.906H3.117V10.484a1.866,1.866,0,0,0,.239.032,3.241,3.241,0,0,0,2.331-1,3.33,3.33,0,0,0,2.4,1,3.283,3.283,0,0,0,2.321-.978,3.394,3.394,0,0,0,2.384.978,3.289,3.289,0,0,0,2.331-1,3.241,3.241,0,0,0,2.331,1,1.866,1.866,0,0,0,.239-.032v6.341Zm.739-8.906a1.218,1.218,0,0,1-.978.494,1.307,1.307,0,0,1-1.259-1.2l-.6-5.11L17.6,2.093l1.093,4.6A1.43,1.43,0,0,1,18.428,7.918Z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding);
export default __webpack_public_path__ + "static/media/Onboarding.334f1b71bc740a6a8eb23133d102480b.svg";
export { ForwardRef as ReactComponent };